// Domínio neutro de login do OAuth (autenticacao.click.app): é por onde entra quem autoriza um app
// (ex.: o conector do Claude) e serve a todas as marcas white label — antes do login não se sabe de
// qual marca a pessoa é. Nele o login sai sem logo, redes sociais, Cadastre-se e Google, e a aba sem
// o título e o favicon da marca. A lista vem de VUE_APP_DOMINIOS_NEUTROS (separada por vírgula).
// autenticacao-dev.click.app: o mesmo papel no ambiente de desenvolvimento (auth-dev.click.app, banco erpdev).
const DOMINIOS_NEUTROS = (process.env.VUE_APP_DOMINIOS_NEUTROS || 'autenticacao.click.app,autenticacao-dev.click.app')
    .split(',')
    .map((d) => d.trim().toLowerCase())
    .filter(Boolean)

export function dominioNeutro() {
    if (typeof window === 'undefined') {
        return false
    }
    return DOMINIOS_NEUTROS.includes(String(window.location.hostname || '').toLowerCase())
}
